module.exports = __webpack_public_path__ + "static/img/arrow.2ee950d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite/arrow.png
// module id = 4kSa
// module chunks = 0